/**
 * 登录日志 API
 */

import { http } from '../request';
import type { LoginLog, LoginLogListResponse, LoginLogQueryParams } from '../../types/loginLog';

/**
 * 分页查询登录日志
 */
export function getLoginLogPage(params?: LoginLogQueryParams): Promise<LoginLogListResponse> {
  return http.get<LoginLogListResponse>('/system/loginlog/page', params);
}

/**
 * 删除登录日志
 */
export function deleteLoginLogs(logIds: number[]): Promise<void> {
  return http.delete('/system/loginlog', logIds);
}

/**
 * 清空登录日志
 */
export function clearLoginLogs(): Promise<void> {
  return http.delete('/system/loginlog/clear');
}
